import { animate, state, style, transition, trigger } from '@angular/animations';

const ANIMATION_TIMING = '200ms linear';
export const SECONDARY_HEADER_ANIMATIONS = [
  trigger('fadeInOut', [
    state('0', style({
      opacity: 1,
      zIndex: '20',
      visibility: 'visible'
    })),
    state('1', style({
      opacity: 0,
      zIndex: '10',
      visibility: 'hidden'
    })),
    transition('0 <=> 1', [
      animate(ANIMATION_TIMING)
    ])
  ]),
  trigger('grow', [
    state('0', style({
      zIndex: '20',
    })),
    state('1', style({
      zIndex: '30',
      width: '100%',
      left: '50%',
      marginLeft: '-50%'
    })),
    transition('0 <=> 1', [
      animate(ANIMATION_TIMING)
    ])
  ])
];
